const getActiveSurveys = (state) => {
  return state.surveys
}

export default {
  getActiveSurveys,
}
